import {
  VEHICLE_DOCUMENT_NAMES,
  COMPANY_DOCUMENT_NAMES,
  USER_DOCUMENT_NAMES,
  WEBLOGIN_VEHICLE_DOCUMENT_NAMES_CREDITOR_UPLOADABLE,
  WEBLOGIN_VEHICLE_DOCUMENT_NAMES_DEBITOR_UPLOADABLE,
} from './constants';

export const getOriginalFileNameOptions = (type, weblogin = false, isCreditor = false, isDebitor = false) => {
  if (type === 'vehicle' && weblogin) {
    let types = [];
    if (isCreditor) {
      types = WEBLOGIN_VEHICLE_DOCUMENT_NAMES_CREDITOR_UPLOADABLE;
    }
    if (isDebitor) {
      types = WEBLOGIN_VEHICLE_DOCUMENT_NAMES_DEBITOR_UPLOADABLE;
    }
    return types;
  }
  if (type === 'vehicle') {
    return VEHICLE_DOCUMENT_NAMES;
  }

  if (type === 'company') {
    return COMPANY_DOCUMENT_NAMES;
  }

  if (type === 'user') {
    return USER_DOCUMENT_NAMES;
  }

  return;
};
